<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <!-- اورلی ذخیره‌سازی خودکار -->
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
        <div class="text-center d-flex flex-column align-center justify-center">
          <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
          <h3 class="mt-4 green--text">در حال ذخیره‌سازی خودکار تغییرات حضور و غیاب...</h3>
          <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
        </div>
      </v-overlay>

      <!-- نمای گیت‌وی ویرایش سریع -->
      <v-row class="pa-2" no-gutters v-if="showGatewayPopup">
        <v-col cols="12">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="gatewaySections"
            :form-data="data"
            @edit-all="handleEditAll"
            @save="qrUpdate(true, false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="loading"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <AttendanceQrView v-model="data" :qr-svg-data-url="qrSvgDataUrl"/>
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>
      </v-row>

      <!-- پنل ویرایش اصلی استپر -->
      <v-card flat :disabled="loading" v-if="!showGatewayPopup">
        <v-row class="pa-2" no-gutters>
          <!-- ستون پیش‌نمایش در دسکتاپ و موبایل -->
          <v-col
            class="pa-2 sticky-md text-center align-items-center"
            cols="12"
            md="4"
            style="top: 10px; height: fit-content"
          >
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="gray"
            ></v-progress-circular>
            <AttendanceQrView v-else v-model="data" :qr-svg-data-url="qrSvgDataUrl"/>
          </v-col>

          <v-col cols="12" md="8">
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p class="font-weight-bold">ویرایش مشخصات کیوآر حضور و غیاب</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        append-icon="mdi-briefcase-check"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="عنوان فرم / ایستگاه حضور و غیاب *"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="عنوان کیوآر"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        readonly
                        outlined
                        persistent-hint
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="شناسه کیوآر"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>

              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <!-- بخش سوییچ ذخیره خودکار -->
                <div class="mb-4">
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                      </span>
                    </v-tooltip>
                  </div>

                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود.
                  </div>
                </div>

                <!-- لیست آکاردئونی کامپوننت‌های سه‌گانه: هماهنگ با فرم اصلی -->
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  :info="res"
                  :service-name="serviceName"
                  :component-name="componentName"
                  flat
                  @save-required="AutoSave && qrUpdate(false, false)"
                />

                <div class="col-md-12 mt-4">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(false, true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";
import AttendanceQrView from "./components/attendanceQrView.vue";

export default {
  name: "attendanceQrEdit",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrEditGateway,
    AtomSpinner,
    AttendanceQrView,
  },

  data() {
    return {
      qrSvgDataUrl: '',
      isAutoSaving: false,
      AutoSave: false,
      showGatewayPopup: false,
      helpData: [],
      serviceName: "Qrland",
      componentName: "attendanceQrEdit",
      e6: 1,
      qrShow: 1,
      loading: false,
      errors: {},
          data: {
      visitName: "",
      CompanyAttendanceBaseInfo: {
        image: "",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: "", text: "" }],
        companyNumber: "",
        companyNumberName: "",
        allowedRadius: 100,
        shifts: [],
        address: "",
        coordinates: [51.420296, 35.732379],
        sectionColor: {
          backGround: "#ffffff",
          text: "#333333",
        },
      },
      // این بخش در data اولیه ادیت جا افتاده بود:
      AttendanceActionSettings: {
        actions: []
      },
      AttendanceRegistrationFields: {
        items: [],
      },
      pallete: {
        headColor: "linear-gradient(135deg, #1b8d39 0%, #0d5f23 100%)",
        bodyColor: "#f7f9fa",
        textColor: "#2c3e50",
        borderColor: "#e0e0e0",
      },
    },
      res: {},
    
    };
  },

  created() {
    this.showGatewayPopup = this.$route?.query?.gateway === "true";
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    specialInfo() {
      return [
         {
          name: "CompanyAttendanceBaseInfo",
          value: "",
          title: "اطلاعات شرکت و شیفت‌های کاری",
          subtitle: "تنظیم موقعیت جغرافیایی، شعاع مجاز و ساعت شیفت‌ها",
          icon: "domain",
          model: "CompanyAttendanceBaseInfo"
        },
        {
          name: "AttendanceActionSettings",
          value: "",
          title: "تنظیم دکمه‌های عملیات تردد",
          subtitle: "فعال/غیرفعال‌سازی، تغییر نام و مرتب‌سازی کلیدهای اسکن",
          icon: "gesture-tap-button",
          model: "AttendanceActionSettings",
          settings: {
            notColor: true
          }
        },
        {
          name: "AttendanceRegistrationFields",
          value: "",
          title: "فیلدهای فرم ثبت اطلاعات پرسنل",
          subtitle: "تنظیم آیتم‌های دریافت اطلاعات و اعتبارسنجی پرسنل",
          icon: "form-select",
          model: "AttendanceRegistrationFields",
          settings: {
            notColor: true
          }
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ و قالب ظاهری",
          subtitle: "شخصی‌سازی تم صفحه ثبت تردد پرسنل",
          icon: "format-color-fill",
          model: "pallete"
        }
      ];
    },

    domainName() {
      return this.$route.params?.name?.replace("?gateway=true", "");
    },

    qrId() {
      return this.$route.params?.id?.replace("?gateway=true", "");
    },

    gatewaySections() {
      return this.specialInfo.map((item) => {
        return { ...item, description: item.title };
      });
    },
  },

  methods: {
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    ...mapActions("localstorage", ["setCreatedQrID"]),

    handleEditAll() {
      this.showGatewayPopup = false;
    },

    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    fetchData() {
  this.loading = true;

  this.$api
    .get(
      `/v1/testQr/find/${this.domainName}${
        this.qrId ? "/" + this.qrId : ""
      }`
    )
    .then(({ data }) => {
      const payload = data.data;
      
      // ممکن است data یک لایه استرینگ JSON باشد یا مستقیماً آبجکت
      let parsedData = payload?.data;
      if (typeof parsedData === "string") {
        try {
          parsedData = JSON.parse(parsedData);
        } catch (e) {
          parsedData = {};
        }
      }
      parsedData = parsedData?.data || parsedData || {};

      this.qrSvgDataUrl = data?.data?.img_url || "";

      // ۱. بررسی و نرمال‌سازی داده‌های پایه شرکت بدون شکستن رفرنس
        const baseSource =
          parsedData.CompanyAttendanceBaseInfo ||
          parsedData.baseInfo ||
          {};

        let parsedShifts = [];
        if (Array.isArray(baseSource.shifts) && baseSource.shifts.length > 0) {
          parsedShifts = baseSource.shifts;
        } else if (baseSource.workStartTime && baseSource.workEndTime) {
          parsedShifts = [
            {
              name: "شیفت کاری",
              startTime: baseSource.workStartTime,
              endTime: baseSource.workEndTime,
            },
          ];
        }

        // با Object.assign رفرنس حفظ شده و فیلدها مستقیماً داخل آبجکت reactive می‌نشینند
        Object.assign(this.data.CompanyAttendanceBaseInfo, {
          organizationName: baseSource.organizationName || baseSource.companyName || "",
          subOrgan: baseSource.subOrgan || baseSource.slogan || "",
          userName: baseSource.userName || "",
          workField: baseSource.workField || "",
          phoneNumber: Array.isArray(baseSource.phoneNumber) && baseSource.phoneNumber.length
            ? baseSource.phoneNumber
            : [{ number: "", text: "" }],
          companyNumber: baseSource.companyNumber || "",
          companyNumberName: baseSource.companyNumberName || "",
          image: baseSource.image || "",
          coordinates: Array.isArray(baseSource.coordinates) && baseSource.coordinates.length
            ? baseSource.coordinates
            : [51.420296, 35.732379],
          address: baseSource.address || "",
          allowedRadius: Number(baseSource.allowedRadius) || 100,
          shifts: parsedShifts,
          sectionColor: baseSource.sectionColor || {
            backGround: "#ffffff",
            text: "#333333",
          },
        });

        // ۲. مقداردهی تنظیمات دکمه‌ها
        const actionSource = parsedData.AttendanceActionSettings || {};
        if (actionSource.actions || Array.isArray(actionSource)) {
          this.$set(this.data, "AttendanceActionSettings", actionSource);
        } else {
        // فال‌بک پیش‌فرض اگر در دیتابیس قدیمی چیزی ذخیره نشده بود
        this.$set(this.data, "AttendanceActionSettings", {
          actions: [
            { id: "check_in", label: "ثبت ورود پرسنل", icon: "mdi-fingerprint", color: "success", active: true, outlined: false },
            { id: "check_out", label: "ثبت خروج پرسنل", icon: "mdi-fingerprint", color: "error", active: true, outlined: true },
            { id: "traffic", label: "ثبت تردد آزاد", icon: "mdi-swap-horizontal", color: "primary", active: false, outlined: true },
            { id: "hourly_leave", label: "مرخصی ساعتی", icon: "mdi-clock-out", color: "warning", active: false, outlined: true },
            { id: "mission", label: "ثبت ماموریت", icon: "mdi-briefcase-check", color: "info", active: false, outlined: true }
          ]
        });
      }

      // ۳. نرمال‌سازی فیلدهای ثبت‌نام پرسنل (آکاردئون سوم)
      const formSource =
        parsedData.AttendanceRegistrationFields ||
        parsedData.consultationNew ||
        {};

      this.$set(this.data, "AttendanceRegistrationFields", {
        conform: formSource.conform || false,
        items: formSource.items || parsedData.forms || [],
      });

      // ۴. پالت رنگ (آکاردئون چهارم)
      if (parsedData.pallete) {
        this.$set(this.data, "pallete", {
          ...this.data.pallete,
          ...parsedData.pallete,
        });
      }

      this.data.visitName = payload.title || parsedData.visitName || "";
      this.res = payload;

      this.setCreatedQrID(payload.id);
      this.updateQrInfo(payload);
      this.updateQridentifier(payload.identifier);
      this.updateQrDomain(payload.domain_id);
      this.updateQrId(payload.id);
    })
    .catch((err) => {
      console.error("Error fetching attendance QR data:", err);
      this.$toast.error("خطا در بارگذاری اطلاعات کیوآر");
    })
    .finally(() => {
      this.loading = false;
    });
}
,

    qrUpdate(isGateway = false, final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }

      this.data.visitName = this.res.title;

      const data = new URLSearchParams();
      data.append("type", "attendanceqr");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain?.name || "");
      data.append("identifier", this.res.identifier || "");
      data.append("qr_id", this.res.qrId || this.res.id);

      // ارسال داده‌های اصلاح‌شده و هماهنگ
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        })
      );

      this.$api
        .put("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then(() => {
          if (final || !this.AutoSave) {
            this.$toast.success("تنظیمات کیوآر حضور و غیاب با موفقیت ویرایش شد");
          }
          this.$root.$emit("submitFeedback");

          if (!isGateway && final) {
            this.$router.push({ name: "qr.list" });
          }
        })
        .catch(({ response }) => {
          console.error("Error updating QR:", response);
          this.$toast.error("خطا در ذخیره‌سازی اطلاعات");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}

[dir="rtl"] .contentinfo,
[dir="rtl"] .rowinfo {
  text-align: right;
}
[dir="ltr"] .contentinfo,
[dir="ltr"] .rowinfo {
  text-align: left;
}
</style>
